// Navbar mega-menu data for the expanded Moneyyard Capital top-nav.

export const ABOUT_LINKS = [
  { slug: "overview", label: "Overview", desc: "Who we are and what we stand for." },
  { slug: "leadership", label: "Leadership", desc: "The principals behind Moneyyard." },
  { slug: "brand-story", label: "Brand Story", desc: "Our journey, philosophy and ethos." },
  { slug: "pressclub", label: "Pressclub", desc: "What the press has been saying." },
  { slug: "sustainability", label: "Sustainability", desc: "Our responsible investing vision." },
];

export const WEALTH_LINKS = [
  { slug: "family-businesses", label: "Family Businesses", desc: "Multi-generational advisory." },
  { slug: "investment-advisory", label: "Investment Advisory", desc: "Independent, conflict-free." },
  { slug: "succession", label: "Succession", desc: "Structured intergenerational transitions." },
  { slug: "governance", label: "Governance", desc: "Family-office governance frameworks." },
  { slug: "philanthropy", label: "Philanthropy", desc: "Impact-led giving strategies." },
  { slug: "setting-up-family-office", label: "Setting up a Family Office", desc: "End-to-end family-office build." },
];

export const INVESTMENT_SOLUTIONS = [
  { slug: "mutual-funds", label: "Mutual Funds" },
  { slug: "stocks-demat", label: "Stocks & Demat Accounts" },
  { slug: "nri-investment", label: "NRI Investment Services" },
  { slug: "pms-aif", label: "PMS & AIF" },
  { slug: "structured-investment-funds", label: "Structured Investment Funds (SIF)" },
  { slug: "gift-city-funds", label: "GIFT City Funds" },
  { slug: "corporate-fds-bonds", label: "Corporate FDs & Bonds" },
  { slug: "treasury-management", label: "Treasury Management" },
  { slug: "wills-estate-planning", label: "Wills & Estate Planning" },
  { slug: "portfolio-restructuring", label: "Portfolio Restructuring" },
  { slug: "retirement-planning", label: "Retirement Planning" },
  { slug: "succession-planning", label: "Succession Planning" },
];

export const CLIENT_SEGMENTS = [
  {
    slug: "ultra-hni-family-businesses",
    title: "Ultra HNI & Family Businesses",
    asset: "Investable assets > INR 100 Cr",
    desc: "Comprehensive wealth advisory and strategic planning for multi-generational family businesses and ultra-high-net-worth families.",
    services: [
      "Family Office Advisory",
      "Succession Planning",
      "Governance Structuring",
      "Philanthropy Advisory",
      "Strategic Investment Planning",
      "Legacy & Estate Structuring",
    ],
  },
  {
    slug: "global-indians",
    title: "Global Indians",
    asset: "Investable assets > INR 5 Cr",
    desc: "Strategic investment advisory for global Indian families seeking structured access to Indian markets and long-term preservation.",
    services: [
      "India-focused Investment Advisory",
      "Estate Planning & Wealth Transfer",
      "Philanthropy & Impact Investing",
      "Analytics & Performance Reports",
      "Cross-border Wealth Structuring",
      "Tax-efficient Planning",
    ],
  },
  {
    slug: "professionals-cxo",
    title: "Professionals & CXOs",
    asset: "Investable assets > INR 10 Cr",
    desc: "Tailored wealth management for senior professionals, business leaders, and corporate executives navigating complex responsibilities.",
    services: [
      "Investment Advisory",
      "Retirement Planning",
      "Portfolio Restructuring",
      "Estate Planning",
      "Wealth Preservation Strategies",
      "Executive Compensation Planning",
    ],
  },
  {
    slug: "media-sports-entertainment",
    title: "Media, Sports & Entertainment",
    asset: "Investable assets > INR 5 Cr",
    desc: "Wealth advisory tailored to the unique and evolving needs of professionals in the entertainment, media, and sports ecosystem.",
    services: [
      "Wealth Preservation",
      "Brand & Royalty Structuring",
      "Cash Flow Planning",
      "Tax-efficient Investing",
      "Global Asset Diversification",
      "Legacy Planning",
    ],
  },
  {
    slug: "founders-entrepreneurs",
    title: "Founders & Entrepreneurs",
    asset: "Investable assets > INR 5 Cr",
    desc: "Comprehensive personal wealth planning for India's notable startup founders, from pre-liquidity to post-exit stages.",
    services: [
      "Pre & Post Exit Planning",
      "Concentrated Equity Management",
      "Treasury Solutions",
      "Family Office Structuring",
      "Risk & Liquidity Planning",
      "Succession & Legacy Advisory",
    ],
  },
];

export const INSIGHTS_LINKS = [
  { slug: "market-outlook", label: "Market Outlook" },
  { slug: "research-reports", label: "Research & Reports" },
  { slug: "investment-insights", label: "Investment Insights" },
  { slug: "wealth-perspectives", label: "Wealth Perspectives" },
  { slug: "economic-updates", label: "Economic Updates" },
];

export const CONTACT_LINKS = [
  { slug: "schedule-consultation", label: "Schedule a Consultation" },
  { slug: "office-locations", label: "Office Locations" },
  { slug: "client-support", label: "Client Support" },
];

// Re-export for legacy named import compatibility
export const WEALTH_SEGMENTS = CLIENT_SEGMENTS;
